WiseMetering.Collection.Actuators = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Actuator,
    url: '/actuators'
});
